import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { addresses: Array, prefix: String }
  static targets = [
    "name", "countryCode", "phone", "address",
    "city", "state", "zip", "country"
  ]

  fill(event) {
    const selectedId = event.target.value
    if (!selectedId) return

    const addr = this.addressesValue.find(a => String(a.id) === String(selectedId))
    if (!addr) return

    this.nameTarget.value = addr.full_name || ""
    this.countryCodeTarget.value = addr.country_code || ""
    this.phoneTarget.value = addr.telephone || ""
    this.addressTarget.value = addr.address || ""
    this.cityTarget.value = addr.city || ""
    this.stateTarget.value = addr.state || ""
    this.zipTarget.value = addr.postal_code || ""
    this.countryTarget.value = addr.country || ""
  }
}
